import React, {useEffect, useMemo} from "react";
import {Helmet} from "react-helmet";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";

// Components
import Contact_img from "../../assets/svg/motor/09_motor_Agencias.svg";
import {useLocaleProvider} from "../../context/localeContext";

const messages = defineMessages({
  titleSEO: {
    id: "page.contact.titleSEO",
    description: "Contact Witbooking",
    defaultMessage: "Contactar con Witbooking",
  },
  descriptionSEO: {
    id: "page.contact.descriptionSEO",
    description: "Receive information from the Witbooking booking engine, become a Witbooking distributor",
    defaultMessage: "Recibir información del motor de reservas Witbooking, ser distribuidor de Witbooking",
  },
  keywordSEO: {
    id: "page.contact.keywordSEO",
    description: "Information, booking engine, distributor, prescriber",
    defaultMessage: "Información, motor de reservas, distribuidor, prescriptor",
  },
  breadcrumb: {
    id: "page.contact.breadcrumb",
    description: "page contact breadcrumb",
    defaultMessage: "Contacto",
  },
  title: {
    id: "page.contact.pageTitle",
    description: "page contact title",
    defaultMessage: "Contacto",
  },
  intro: {
    id: "page.contact.pageIntro",
    description: "page contact intro",
    defaultMessage:
      "Contacta con nosotros si necesitas más información o una demo online del motor de reservas o de cualquiera de nuestros módulos. Si estás interesado en ser prescriptor o distribuidor estaremos encantados te informaremos de nuestro programa de partners.",
  },
  formDefault: {
    id: "page.contact.formDefault",
    description: "contact form default",
    defaultMessage: "Seleccionar",
  },
  formConsult: {
    id: "page.contact.formConsult",
    description: "contact form consult",
    defaultMessage: "Tipo de consulta",
  },
  formConsultOption1: {
    id: "page.contact.formConsultOption1",
    description: "contact form consult option 1",
    defaultMessage: "Deseo que me llame un agente",
  },
  formConsultOption2: {
    id: "page.contact.formConsultOption2",
    description: "contact form consult option 2",
    defaultMessage: "Deseo recibir información comercial por email.",
  },
  formConsultOption3: {
    id: "page.contact.formConsultOption3",
    description: "contact form consult option 3",
    defaultMessage:
      "Deseo recibir información para ser prescriptor o distribuidor",
  },
  formName: {
    id: "page.contact.formName",
    description: "contact form name",
    defaultMessage: "Nombre",
  },
  formCompany: {
    id: "page.contact.formCompany",
    description: "contact form company",
    defaultMessage: "Empresa",
  },
  formPhone: {
    id: "page.contact.formPhone",
    description: "contact form phone",
    defaultMessage: "Teléfono",
  },
  formEmail: {
    id: "page.contact.formEmail",
    description: "contact form email",
    defaultMessage: "Email",
  },
  formWeb: {
    id: "page.contact.formWeb",
    description: "contact form web",
    defaultMessage: "Web",
  },
  formCountry: {
    id: "page.contact.formCountry",
    description: "contact form copuntry",
    defaultMessage: "País",
  },
  formMessage: {
    id: "page.contact.formMessage",
    description: "contact form message",
    defaultMessage: "Mensaje",
  },
  formMust: {
    id: "page.contact.formMust",
    description: "contact form must",
    defaultMessage: "* Campos obligatorios",
  },
  formConditions: {
    id: "page.contact.formConditions",
    description: "contact form conditions",
    defaultMessage: "Sí, acepto las",
  },
  formConditionsLink: {
    id: "page.contact.formConditionsLink",
    description: "contact form conditions link",
    defaultMessage: "condiciones de privacidad",
  },
  formNews: {
    id: "page.contact.formNews",
    description: "contact form news",
    defaultMessage: "Sí, deseo recibir novedades",
  },
  formBtn: {
    id: "page.contact.formBtn",
    description: "contact form button",
    defaultMessage: "Enviar",
  },
  formSuccess: {
    id: "page.contact.formSuccess",
    description: "contact form success",
    defaultMessage: "Su solicitud ha sido recibida correctamente, nos pondremos en contacto con usted a la mayor brevedad posible.",
  },
  formError: {
    id: "page.contact.formError",
    description: "contact form error",
    defaultMessage: "Ha ocurrido un error.",
  },
    formRequiredFieldsError: {
    id: "page.contact.formRequiredFieldsError",
    description: "contact form error",
    defaultMessage: "*campos obligatorios pendientes",
  },
  select: {
    id: "page.contact.select",
    description: "select",
    defaultMessage: "Seleccionar",
  },
});

export default function HubspotContact({locale}) {
  const intl = useIntl();
  const localeProvider = useLocaleProvider();
  const isSelectedEnglish = useMemo(
    () => localeProvider.currentLocale === "en-US",
    [localeProvider]
  );


  useEffect(() => {
    // Load the HubSpot forms script
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.defer = true;
    document.body.appendChild(script);

    // When the script loads, create the form
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "20410676",
          formId: "bc7ba1d8-3623-4359-8033-c222e7c28f68",
          region: "na1",
          target: "#hubspot-form",
        });
      }
    };

    // Cleanup script on unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(messages.titleSEO)}</title>
        <meta name="title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta name="description" content={intl.formatMessage(messages.titleSEO)}/>
        <meta name="keywords" content={intl.formatMessage(messages.keywordSEO)}/>

        <meta property="og:type" content="website"/>
        <meta property="og:url" content="https://metatags.io/"/>
        <meta property="og:title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta property="og:description" content={intl.formatMessage(messages.descriptionSEO)}/>
        <meta property="og:image"
              content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"/>

        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content="https://metatags.io/"/>
        <meta property="twitter:title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta property="twitter:description" content={intl.formatMessage(messages.descriptionSEO)}/>
        <meta property="twitter:image"
              content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"/>
      </Helmet>
      <section className="contact-page half-wrapper responsive-multimedia-off">
        <div className="half-breadcrumbs color">
          <ol
            className="breadcrumbs-list"
            itemScope
            itemType="http://schema.org/BreadcrumbList"
          >
            <li
              className="breadcrumbs-list-element"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              <a itemProp="item" href="/">
                <span className="breadcrumbs-element-text" itemProp="name">
                  Home
                </span>
              </a>
              <span itemProp="position" content="1">
                &gt;
              </span>
            </li>
            <li
              className="breadcrumbs-list-element active"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              <a
                itemProp="item"
                href={isSelectedEnglish ? "/contact" : "/contacto"}
              >
                <span className="breadcrumbs-element-text" itemProp="name">
                  <FormattedMessage {...messages.breadcrumb} />
                </span>
              </a>
              <span itemProp="position" content="2">
                &gt;
              </span>
            </li>
          </ol>
        </div>
        <div className="wrapper">
          <div className="wrap-contact-page">
            <header className="contact-page-header">
              <div className="wrap-contact-header">
                <h1 className="contact-header-title">
                  <FormattedMessage {...messages.title} />
                </h1>
              </div>
            </header>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text">
                  <FormattedMessage {...messages.intro} />
                </p>
              </div>
            </div>
            <div className="wrap-contact-form">
              <div className="contact-form-fields">
                <div >

                  <div id="hubspot-form" className="hubspot-form contact-page-form">
                  </div>
                </div>
              </div>
            </div>
            <div className="half-multimedia">
              <div className="wrap-half-multimedia">
                <div className="half-multimedia-box">
                  <div className="wrap-multimedia-box">
                    <img
                      alt="contact"
                      className="multimedia-box-element"
                      data-lazyimg={Contact_img}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
